/* fs-quiz — Find Your Stack engine.
   Questions → answers → EMAIL GATE (required) → recommend stacks (from quiz_stack metaobjects)
   → result cards (real products/prices) → AJAX add-to-cart. Logged-in users skip the gate. */
(function () {
  var root = document.querySelector('[data-fs-quiz]');
  if (!root) return;
  var engine = root.querySelector('#fsQuizEngine');
  if (!engine) return;

  /* ---- data ---- */
  var STACKS = [];
  var LAST_BUY = []; /* products shown in the latest result — for variant→selling_plan lookup */
  var CONFIG = { discountPct: 15, welcomeNote: '' };
  try { STACKS = JSON.parse(root.querySelector('[data-fs-quiz-stacks]').textContent) || []; } catch (e) {}
  try { CONFIG = Object.assign(CONFIG, JSON.parse(root.querySelector('[data-fs-quiz-config]').textContent)); } catch (e) {}

  var LOGGED_IN = engine.getAttribute('data-logged-in') === 'true';
  var CUSTOMER_EMAIL = engine.getAttribute('data-customer-email') || '';

  /* same SVG icon set as the homepage goal-selector (shop_images), CSS-masked so we can recolour.
     One source of truth → home + quiz + result icons match. */
  var ICON_FILES = {};
  try { ICON_FILES = JSON.parse(root.querySelector('[data-fs-quiz-icons]').textContent) || {}; } catch (e) {}
  /* quiz goal_key / category → homepage icon key */
  var ICON_KEY = {
    sleep:'sleep', gut:'gut', fitness:'energy', brain:'brain', beauty:'skin',
    energy:'energy', weight:'weight', longevity:'immunity', immunity:'immunity',
    hormone:'womens', joint:'bone', stress:'sleep', heart:'heart', detox:'detox'
  };
  /* render an icon as a recolourable CSS mask; falls back to inline catIcon if the file is missing */
  function maskIcon(key, size, color) {
    var ik = ICON_KEY[key] || key;
    var url = ICON_FILES[ik];
    size = size || 28;
    color = color || 'var(--color-forest, #2B4A2D)';
    if (!url) return catIcon('', size, color, GOAL_ICONS[key] || CONCERN_ICONS[key] || 'leaf');
    return '<span class="fs-quiz__svgicon" style="width:' + size + 'px;height:' + size + 'px;background:' + color + ';-webkit-mask:url(' + url + ') center/contain no-repeat;mask:url(' + url + ') center/contain no-repeat;"></span>';
  }

  /* ---- questions (fixed keys, match metaobject goal_key values) ---- */
  var QUIZ = [
    { q: 'What is your primary wellness goal?', type: 'single', key: 'goal', opts: [
      { label: 'Sleep & stress', val: 'sleep', desc: 'Rest deeper, feel calmer' },
      { label: 'Gut & digestion', val: 'gut', desc: 'Less bloat, better balance' },
      { label: 'Strength & recovery', val: 'fitness', desc: 'Train harder, bounce back' },
      { label: 'Focus & memory', val: 'brain', desc: 'Think sharp, stay clear' },
      { label: 'Skin & hair', val: 'beauty', desc: 'Visible glow and growth' },
      { label: 'Energy & vitality', val: 'energy', desc: 'Steady, all-day fuel' },
      { label: 'Weight & metabolism', val: 'weight', desc: 'Balanced, sustainable results' },
      { label: 'Healthy ageing', val: 'longevity', desc: 'Age strong, cell-deep' }
    ] },
    { q: 'Which of these concerns bother you most?', sub: 'Choose all that apply', type: 'multi', key: 'concerns', opts: [
      { label: 'Low energy or fatigue', val: 'energy' },
      { label: 'Stress or anxiety', val: 'stress' },
      { label: 'Poor sleep quality', val: 'sleep' },
      { label: 'Digestive issues', val: 'gut' },
      { label: 'Dull skin or hair loss', val: 'beauty' },
      { label: 'Joint pain or stiffness', val: 'joint' },
      { label: 'Brain fog or poor focus', val: 'brain' },
      { label: 'Hormonal imbalances', val: 'hormone' }
    ] },
    { q: 'What format do you prefer for supplements?', type: 'single', key: 'format', opts: [
      { label: 'Capsules & tablets', val: 'capsule', desc: 'Simple, precise daily dosing you can carry anywhere' },
      { label: 'Powders & blends', val: 'powder', desc: 'Mix into water, smoothies, or your morning routine' },
      { label: 'Gummies & chews', val: 'gummy', desc: 'Tasty and chewable — no pills, no water needed' },
      { label: 'Dissolvable strips', val: 'strip', desc: 'Melt-on-the-tongue strips for fast, water-free dosing' },
      { label: 'Drops & liquids', val: 'liquid', desc: 'Fast absorption with a flexible, easy-to-adjust dose' },
      { label: 'No preference', val: 'any', desc: 'Open to any format — just show me what works' }
    ] },
    { q: 'How would you describe your lifestyle?', type: 'single', key: 'lifestyle', opts: [
      { label: 'Active athlete or gym-goer', val: 'athlete', desc: 'Training hard several days each week' },
      { label: 'Busy professional, mostly desk-based', val: 'desk', desc: 'Long hours seated with heavy screen time' },
      { label: 'Parent juggling family & work', val: 'parent', desc: 'Full days, broken sleep, little downtime' },
      { label: 'Health-conscious & holistic', val: 'holistic', desc: 'Daily rituals and intentional, mindful living' },
      { label: 'Older adult ageing gracefully', val: 'senior', desc: 'Joint, heart, and cognitive support matters' }
    ] },
    { q: 'Do you include personal care or topicals in your routine?', type: 'single', key: 'topicals', opts: [
      { label: 'Yes, I use topicals', val: 'yes', desc: 'Pair stacks with creams and serums' },
      { label: 'Sometimes, if helpful', val: 'maybe', desc: 'Add topicals when they fit goals' },
      { label: 'Supplements only', val: 'no', desc: 'Skip topicals and personal care' }
    ] }
  ];

  /* concern → category fallback for matching (some concerns map to a category, not a goal_key) */
  var CONCERN_TO_CAT = { stress: 'energy', joint: 'fitness', hormone: 'hormone' };
  /* Q1 (goal) option → icon key (reuses CAT_ICON_PATHS via catIcon) */
  var GOAL_ICONS = { sleep:'moon', gut:'leaf', fitness:'bolt', brain:'brain', beauty:'sparkle', energy:'sun', weight:'scale', longevity:'helix' };
  /* Q2 (concerns) option → icon key */
  var CONCERN_ICONS = { energy:'sun', stress:'calm', sleep:'moon', gut:'leaf', beauty:'sparkle', joint:'joint', brain:'brain', hormone:'helix' };

  var CHECK = '<svg viewBox="0 0 16 14" width="16" height="14" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="2,7 6,11 14,3"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="2" y1="8" x2="14" y2="8"/><polyline points="9,3 14,8 9,13"/></svg>';
  var ARROW_L = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="14" y1="8" x2="2" y2="8"/><polyline points="7,3 2,8 7,13"/></svg>';
  var PLUS = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>';
  var MAIL = '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>';
  var TARGET = '<svg viewBox="0 0 40 40" width="40" height="40" fill="none" stroke="#B8862A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="20" cy="20" r="18"/><circle cx="20" cy="20" r="12"/><circle cx="20" cy="20" r="6"/></svg>';
  var STAR = '<svg viewBox="0 0 20 18" width="14" height="13" aria-hidden="true"><polygon points="10,1 12.4,7 18,7 13.4,10.6 15.2,17 10,13.5 4.8,17 6.6,10.6 2,7 7.6,7" fill="#B8862A"/></svg>';
  var STAR_EMPTY = '<svg viewBox="0 0 20 18" width="13" height="12" aria-hidden="true"><polygon points="10,1 12.4,7 18,7 13.4,10.6 15.2,17 10,13.5 4.8,17 6.6,10.6 2,7 7.6,7" fill="none" stroke="#B8862A" stroke-width="1.2"/></svg>';
  /* category → icon + tinted bg (designer parity: stack card shows a category icon, not a product photo) */
  var CAT_COLORS = {
    sleep: { tone: '#5B4D7A', soft: '#EDE9F5', icon: 'moon' },
    gut: { tone: '#7A5A3D', soft: '#F5EDE3', icon: 'leaf' },
    fitness: { tone: '#3D6640', soft: '#EBF0EB', icon: 'bolt' },
    brain: { tone: '#4A4F87', soft: '#EBECF4', icon: 'brain' },
    beauty: { tone: '#A47148', soft: '#F5EBE0', icon: 'sparkle' },
    energy: { tone: '#B8862A', soft: '#F3E8D0', icon: 'sun' },
    immunity: { tone: '#456B5C', soft: '#E8EFEB', icon: 'shield' },
    longevity: { tone: '#3D5A6B', soft: '#E5EBEF', icon: 'helix' },
    weight: { tone: '#8B4D3D', soft: '#F0E3DE', icon: 'scale' },
    hormone: { tone: '#8B4B6B', soft: '#F0E3EA', icon: 'flow' }
  };
  var CAT_ICON_PATHS = {
    moon: '<path d="M19 13a8 8 0 11-10-10 7 7 0 0010 10z"/>',
    leaf: '<path d="M4 20C6 12 12 6 22 4c0 10-6 16-15 18"/><line x1="4" y1="20" x2="10" y2="14"/>',
    bolt: 'POLYBOLT',
    brain: '<path d="M9 4a4 4 0 00-4 4 3 3 0 00-3 3 3 3 0 003 3v4h8V4H9z"/><path d="M17 4a4 4 0 014 4 3 3 0 013 3 3 3 0 01-3 3v4h-8V4h3z" transform="translate(-2 0)"/>',
    sparkle: '<path d="M12 2v6m0 8v6m-10-10h6m8 0h6"/><path d="M5 5l4 4m6 6l4 4M5 19l4-4m6-6l4-4"/>',
    sun: '<circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><line x1="5" y1="5" x2="7" y2="7"/><line x1="17" y1="17" x2="19" y2="19"/><line x1="5" y1="19" x2="7" y2="17"/><line x1="17" y1="7" x2="19" y2="5"/>',
    shield: '<path d="M12 2L4 5v7c0 5 3 9 8 11 5-2 8-6 8-11V5l-8-3z"/><polyline points="8,12 11,15 16,9"/>',
    helix: '<path d="M6 3c0 6 12 6 12 12s-12 6-12 12"/><path d="M18 3c0 6-12 6-12 12s12 6 12 12"/>',
    scale: '<line x1="12" y1="3" x2="12" y2="21"/><rect x="3" y="8" width="18" height="6" rx="1"/><path d="M7 14v2m10-2v2"/>',
    flow: '<circle cx="12" cy="12" r="8"/><path d="M8 12c0-2 4-2 4-4s-4-2-4-4"/><path d="M16 12c0 2-4 2-4 4s4 2 4 4"/>',
    /* joint = knee/bone joint */
    joint: '<circle cx="8" cy="6" r="2.4"/><circle cx="16" cy="18" r="2.4"/><path d="M8.7 8l6.6 8"/><path d="M6 9.5l-2 2M18 14.5l2-2"/>',
    /* calm = stress-relief / breathing waves */
    calm: '<path d="M3 9h7a3 3 0 100-6"/><path d="M3 13h12a3 3 0 110 6"/><path d="M3 17h5"/>',
    /* heart */
    heart: '<path d="M12 21C5 16 3 12 3 8.5A4.5 4.5 0 0112 6a4.5 4.5 0 019 2.5C21 12 19 16 12 21z"/>'
  };
  function catIcon(cat, size, color, iconKey) {
    size = size || 48;
    var meta = CAT_COLORS[cat] || {};
    color = color || meta.tone || '#2B4A2D';
    iconKey = iconKey || meta.icon || 'leaf';
    var pathContent = CAT_ICON_PATHS[iconKey] || CAT_ICON_PATHS.leaf;
    if (iconKey === 'bolt') pathContent = '<polygon points="14,2 4,14 11,14 10,22 20,10 13,10" fill="' + color + '" stroke="none"/>';
    return '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + pathContent + '</svg>';
  }
  /* lighten a hex to a soft tint for the card bg (mix ~14% colour with white) */
  function hexToSoft(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || '').trim());
    if (!m) return '#EBF0EB';
    var r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16), k = 0.14;
    function mix(c) { return Math.round(c * k + 255 * (1 - k)); }
    return 'rgb(' + mix(r) + ',' + mix(g) + ',' + mix(b) + ')';
  }

  /* row of stars for a real rating (0-5), filled to the nearest half */
  function starRow(r) {
    r = Number(r) || 0;
    var full = Math.floor(r), half = (r - full) >= 0.5, out = '';
    for (var i = 0; i < 5; i++) {
      if (i < full) out += '<svg viewBox="0 0 20 18" width="13" height="12" aria-hidden="true"><polygon points="10,1 12.4,7 18,7 13.4,10.6 15.2,17 10,13.5 4.8,17 6.6,10.6 2,7 7.6,7" fill="#B8862A"/></svg>';
      else if (i === full && half) out += '<svg viewBox="0 0 20 18" width="13" height="12" aria-hidden="true"><defs><linearGradient id="fsh' + i + '"><stop offset="50%" stop-color="#B8862A"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><polygon points="10,1 12.4,7 18,7 13.4,10.6 15.2,17 10,13.5 4.8,17 6.6,10.6 2,7 7.6,7" fill="url(#fsh' + i + ')" stroke="#B8862A" stroke-width="1"/></svg>';
      else out += STAR_EMPTY;
    }
    return out;
  }

  /* result-count bounds (theme editor: Min/Max stacks to show). */
  var MAX_RECS = parseInt(CONFIG.maxRecs, 10); if (!MAX_RECS || MAX_RECS < 1) MAX_RECS = 3;
  var MIN_RECS = parseInt(CONFIG.minRecs, 10); if (!MIN_RECS || MIN_RECS < 1) MIN_RECS = 1;
  if (MIN_RECS > MAX_RECS) MIN_RECS = MAX_RECS;

  var state = { step: 0, answers: {}, selected: null, multi: [], gatePassed: LOGGED_IN };

  /* ---- progress persistence (sessionStorage) ----
     Keeps quiz answers/step across an accidental page refresh. Tab-scoped, so it
     clears when the tab closes; also cleared on restart or once the result shows. */
  var SS_KEY = 'fsQuizState';
  function saveState() {
    try {
      sessionStorage.setItem(SS_KEY, JSON.stringify({
        step: state.step, answers: state.answers, selected: state.selected,
        multi: state.multi, gatePassed: state.gatePassed
      }));
    } catch (e) {}
  }
  function clearState() { try { sessionStorage.removeItem(SS_KEY); } catch (e) {} }
  function loadState() {
    try {
      var raw = sessionStorage.getItem(SS_KEY);
      if (!raw) return false;
      var saved = JSON.parse(raw);
      if (!saved || typeof saved.step !== 'number') return false;
      state.step = Math.min(Math.max(saved.step, 0), QUIZ.length);
      state.answers = saved.answers || {};
      state.selected = saved.selected != null ? saved.selected : null;
      state.multi = Array.isArray(saved.multi) ? saved.multi : [];
      state.gatePassed = saved.gatePassed || LOGGED_IN;
      return true;
    } catch (e) { return false; }
  }

  var engineInner = root.querySelector('.fs-quiz__engine-inner');
  function setWide(on) { if (engineInner) engineInner.classList.toggle('is-result-wide', !!on); }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      try { return Shopify.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }
  function progressDots(done) {
    var html = '';
    for (var i = 0; i < QUIZ.length; i++) {
      var cls = done ? 'done' : (i < state.step ? 'done' : (i === state.step ? 'active' : ''));
      html += '<div class="fs-quiz__progress-dot ' + cls + '"></div>';
    }
    return '<div class="fs-quiz__progress">' + html + '</div>';
  }

  /* ---- render a question ---- */
  function renderQuestion() {
    setWide(false);
    var q = QUIZ[state.step];
    var multi = q.type === 'multi';
    /* Q1 goal (icon tiles) + Q2 concerns (checkbox tiles) + Q3/Q4/Q5 (plain tiles) = grid; nothing left as list */
    var isTile = (q.key === 'goal' || q.key === 'concerns' || q.key === 'format' || q.key === 'lifestyle' || q.key === 'topicals');
    var opts = q.opts.map(function (o) {
      if (isTile && q.key === 'goal') {
        /* Q1 goal — single-select icon tiles (distinct homepage icons) */
        var ic = maskIcon(o.val, 28, 'var(--color-forest, #2B4A2D)');
        return '<button type="button" class="fs-quiz__opt fs-quiz__opt--tile" data-val="' + o.val + '" role="radio" aria-checked="false">' +
          '<span class="fs-quiz__opt-icon">' + ic + '</span>' +
          '<span class="fs-quiz__opt-label">' + o.label + '</span>' +
          (o.desc ? '<span class="fs-quiz__opt-desc">' + o.desc + '</span>' : '') + '</button>';
      }
      if (isTile && !multi) {
        /* Q3 format — single-select PLAIN tiles (no icon; label + desc, card-highlight on select) */
        return '<button type="button" class="fs-quiz__opt fs-quiz__opt--tile fs-quiz__opt--plain" data-val="' + o.val + '" role="radio" aria-checked="false">' +
          '<span class="fs-quiz__opt-label">' + o.label + '</span>' +
          (o.desc ? '<span class="fs-quiz__opt-desc">' + o.desc + '</span>' : '') + '</button>';
      }
      if (isTile && multi) {
        /* Q2 concerns — multi-select tiles, NO icon (homepage set has no distinct concern icons),
           proper square checkbox + tick. */
        return '<button type="button" class="fs-quiz__opt fs-quiz__opt--tile fs-quiz__opt--check" data-val="' + o.val + '" role="checkbox" aria-checked="false">' +
          '<span class="fs-quiz__opt-check">' + CHECK + '</span>' +
          '<span class="fs-quiz__opt-label">' + o.label + '</span></button>';
      }
      return '<button type="button" class="fs-quiz__opt" data-val="' + o.val + '" role="' + (multi ? 'checkbox' : 'radio') + '" aria-checked="false">' +
        '<span class="fs-quiz__opt-check">' + CHECK + '</span>' +
        '<span class="fs-quiz__opt-body"><span class="fs-quiz__opt-label">' + o.label + '</span>' +
        (o.desc ? '<span class="fs-quiz__opt-desc">' + o.desc + '</span>' : '') + '</span></button>';
    }).join('');

    var lastStep = state.step === QUIZ.length - 1;
    engine.innerHTML = progressDots(false) +
      '<div class="fs-quiz__q-label">Question ' + (state.step + 1) + ' of ' + QUIZ.length + '</div>' +
      '<h3 class="fs-quiz__q-text">' + q.q + '</h3>' +
      (q.sub ? '<p class="fs-quiz__q-sub">' + q.sub + '</p>' : '') +
      '<div class="fs-quiz__options' + (isTile ? ' fs-quiz__options--grid' : '') + '" role="' + (multi ? 'group' : 'radiogroup') + '">' + opts + '</div>' +
      '<div class="fs-quiz__nav">' +
        '<button type="button" class="fs-quiz__btn" data-back ' + (state.step === 0 ? 'disabled' : '') + '>' + ARROW_L + ' Back</button>' +
        '<button type="button" class="fs-quiz__btn fs-quiz__btn--primary" data-next disabled>' + (lastStep ? 'See My Stack' : 'Continue') + ' ' + ARROW_R + '</button>' +
      '</div>';

    engine.querySelectorAll('.fs-quiz__opt').forEach(function (btn) {
      btn.addEventListener('click', function () { selectOpt(btn, multi); });
    });
    engine.querySelector('[data-back]').addEventListener('click', goBack);
    engine.querySelector('[data-next]').addEventListener('click', goNext);

    /* restore prior selection */
    if (multi) {
      state.multi.forEach(function (v) {
        var b = engine.querySelector('.fs-quiz__opt[data-val="' + v + '"]');
        if (b) { b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true'); }
      });
      if (state.multi.length) engine.querySelector('[data-next]').disabled = false;
    } else if (state.selected) {
      var b2 = engine.querySelector('.fs-quiz__opt[data-val="' + state.selected + '"]');
      if (b2) { b2.classList.add('is-selected'); b2.setAttribute('aria-checked', 'true'); }
      engine.querySelector('[data-next]').disabled = false;
    }
    engine.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function selectOpt(btn, multi) {
    var val = btn.getAttribute('data-val');
    if (multi) {
      var i = state.multi.indexOf(val);
      if (i > -1) { state.multi.splice(i, 1); btn.classList.remove('is-selected'); btn.setAttribute('aria-checked', 'false'); }
      else { state.multi.push(val); btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true'); }
      engine.querySelector('[data-next]').disabled = state.multi.length === 0;
    } else {
      engine.querySelectorAll('.fs-quiz__opt').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
      state.selected = val;
      engine.querySelector('[data-next]').disabled = false;
      /* single-select → auto-advance to the next question (brief pause so the highlight registers) */
      setTimeout(goNext, 280);
    }
  }

  function goNext() {
    var q = QUIZ[state.step];
    state.answers[q.key] = q.type === 'multi' ? state.multi.slice() : state.selected;
    state.step++; state.selected = null; state.multi = [];
    saveState();
    if (state.step >= QUIZ.length) {
      if (state.gatePassed) renderResult(); else renderGate();
    } else renderQuestion();
  }
  function goBack() {
    if (state.step === 0) return;
    state.step--;
    var q = QUIZ[state.step];
    var prev = state.answers[q.key];
    if (q.type === 'multi') { state.multi = Array.isArray(prev) ? prev.slice() : []; state.selected = null; }
    else { state.selected = prev || null; state.multi = []; }
    saveState();
    renderQuestion();
  }

  /* ---- EMAIL GATE (required, logged-out only) ---- */
  function renderGate() {
    setWide(false);
    engine.innerHTML = progressDots(true) +
      '<div class="fs-quiz__gate">' +
        '<div class="fs-quiz__gate-icon">' + MAIL + '</div>' +
        '<div class="fs-quiz__gate-eyebrow">Almost there</div>' +
        '<h3 class="fs-quiz__gate-title">Where should we send <em>your stack?</em></h3>' +
        '<p class="fs-quiz__gate-sub">Enter your email to unlock your personalised recommendation and get 10% off your first order.</p>' +
        '<form class="fs-quiz__gate-form" data-gate-form novalidate>' +
          '<input type="text" class="fs-quiz__gate-input" data-gate-name placeholder="Your full name" autocomplete="name" required>' +
          '<input type="email" class="fs-quiz__gate-input" data-gate-email placeholder="Your email address" autocomplete="email" required>' +
          '<button type="submit" class="fs-quiz__gate-submit" data-gate-submit>Unlock my stack ' + ARROW_R + '</button>' +
        '</form>' +
        '<p class="fs-quiz__gate-error" data-gate-error role="alert"></p>' +
        '<p class="fs-quiz__gate-fine">' + (CONFIG.welcomeNote || '') + '</p>' +
        '<button type="button" class="fs-quiz__gate-back" data-gate-back>' + ARROW_L + ' Back to questions</button>' +
      '</div>';

    engine.querySelector('[data-gate-back]').addEventListener('click', function () {
      state.step = QUIZ.length - 1;
      var q = QUIZ[state.step];
      state.selected = state.answers[q.key] || null;
      renderQuestion();
    });
    engine.querySelector('[data-gate-form]').addEventListener('submit', submitGate);
  }

  function buildTags() {
    var t = ['quiz-lead'];
    if (state.answers.goal) t.push('goal-' + state.answers.goal);
    (state.answers.concerns || []).forEach(function (c) { t.push('concern-' + c); });
    if (state.answers.lifestyle) t.push('lifestyle-' + state.answers.lifestyle);
    return t.join(',');
  }

  function submitGate(e) {
    e.preventDefault();
    var name = (engine.querySelector('[data-gate-name]').value || '').trim().replace(/\s+/g, ' ');
    var email = (engine.querySelector('[data-gate-email]').value || '').trim();
    var err = engine.querySelector('[data-gate-error]');
    var btn = engine.querySelector('[data-gate-submit]');
    if (!name) { err.textContent = 'Please enter your name.'; return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Please enter a valid email address.'; return; }
    err.textContent = '';
    btn.disabled = true;

    /* split full name → first / last (everything after the first space is the last name) */
    var sp = name.indexOf(' ');
    var firstName = sp > -1 ? name.slice(0, sp) : name;
    var lastName = sp > -1 ? name.slice(sp + 1) : '';

    /* submit through the hidden native customer form (creates/updates the Shopify customer + tags).
       We fire it in the background; the quiz proceeds to the result regardless of the redirect. */
    var hostForm = document.getElementById('fsQuizCustomerForm');
    try {
      document.getElementById('fsQuizEmailField').value = email;
      document.getElementById('fsQuizFirstName').value = firstName;
      document.getElementById('fsQuizLastName').value = lastName;
      document.getElementById('fsQuizTags').value = buildTags();
      /* AJAX-post so the page doesn't navigate away from the quiz. Strip any #fragment from the
         action (Shopify renders /contact#formid which 400s as a fetch URL). */
      var fd = new FormData(hostForm);
      var action = (hostForm.getAttribute('action') || '/contact').split('#')[0] || '/contact';
      fetch(action, { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } }).catch(function () {});
    } catch (e2) {}

    /* Klaviyo hook (no-op until Klaviyo is installed) */
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ $email: email, $first_name: firstName, $last_name: lastName });
        window.klaviyo.track('Completed Quiz', {
          goal: state.answers.goal,
          concerns: state.answers.concerns,
          format: state.answers.format,
          lifestyle: state.answers.lifestyle,
          topicals: state.answers.topicals
        });
      }
    } catch (e3) {}

    state.gatePassed = true;
    state.leadEmail = email;
    state.leadName = name;
    renderResult();
  }

  /* ---- recommendation ----
     Match priority for a key: (1) exact goal_key, (2) exact category, (3) concern→category fallback.
     Exact-first so a concern like "stress" picks the Stress stack, not every energy stack. */
  function stacksByKey(key) {
    var exact = STACKS.filter(function (s) { return s.goal_key === key; });
    if (exact.length) return exact.sort(bySort);
    var cat = STACKS.filter(function (s) { return s.category === key; });
    if (cat.length) return cat.sort(bySort);
    var fb = CONCERN_TO_CAT[key];
    return fb ? STACKS.filter(function (s) { return s.category === fb || s.goal_key === fb; }).sort(bySort) : [];
  }
  function getRecommended() {
    var a = state.answers;
    var picked = [];
    var seen = {};
    function add(s) { if (s && !seen[s.id]) { seen[s.id] = 1; picked.push(s); } }

    /* primary goal — its top stack first (this is the BEST MATCH) */
    stacksByKey(a.goal).forEach(add);
    /* concerns — one stack each */
    (a.concerns || []).forEach(function (c) {
      var m = stacksByKey(c);
      if (m[0]) add(m[0]);
    });
    /* lifestyle nudges */
    if (a.lifestyle === 'athlete') { stacksByKey('fitness').forEach(add); }
    if (a.lifestyle === 'senior') { stacksByKey('longevity').forEach(add); stacksByKey('immunity').forEach(add); }
    if (a.lifestyle === 'holistic') { var st = stacksByKey('stress'); if (st[0]) add(st[0]); }

    /* fallback: any stack of the goal category, then anything */
    if (!picked.length) STACKS.filter(function (s) { return s.category === a.goal; }).forEach(add);
    if (!picked.length) STACKS.slice().forEach(add);

    /* pad up to the configured minimum: first same-category stacks, then any others */
    if (picked.length < MIN_RECS) {
      STACKS.filter(function (s) { return s.category === a.goal; }).sort(bySort).forEach(add);
    }
    if (picked.length < MIN_RECS) {
      STACKS.slice().sort(bySort).forEach(add);
    }

    return picked.slice(0, MAX_RECS);
  }
  function bySort(a, b) { return (a.sort_order || 99) - (b.sort_order || 99); }

  /* core product cents sum (the buyable part of a stack) */
  function stackCore(s, includeTopicals) {
    var list = (s.core || []).concat(s.boost ? [] : []);
    return list;
  }
  function stackBuyList(s, includeTopicals) {
    var list = (s.core || []).slice();
    if (s.boost) list = list.concat(s.boost);
    if (includeTopicals && s.topical) list = list.concat(s.topical);
    return list.filter(function (p) { return p && p.available; });
  }
  /* available products of one tier (core/boost/topical) */
  function tierList(arr) {
    return (arr || []).filter(function (p) { return p && p.available; });
  }
  function sumPrice(list, field) { return list.reduce(function (n, p) { return n + (p[field] || 0); }, 0); }

  /* ---- result ---- */
  var GOAL_LABELS = { sleep: 'Restorative Sleep', gut: 'Gut Health', fitness: 'Peak Performance', brain: 'Cognitive Clarity', beauty: 'Radiant Beauty', energy: 'Sustained Energy', weight: 'Metabolic Wellness', longevity: 'Healthy Longevity' };

  function renderResult() {
    setWide(true);
    /* Quiz finished — mark it done so a refresh returns to the result, and keep the
       saved snapshot only up to the result (not re-asking questions). */
    state.step = QUIZ.length; saveState();
    var recs = getRecommended();
    var a = state.answers;
    var includeTopicals = a.topicals !== 'no';
    var goalLabel = GOAL_LABELS[a.goal] || 'Wellness';
    var allWord = recs.length === 1 ? 'it' : (recs.length === 2 ? 'both' : (recs.length === 3 ? 'all three' : 'them all'));

    if (!recs.length) {
      engine.innerHTML = progressDots(true) + '<div class="fs-quiz__result"><h3 class="fs-quiz__result-title">No match found.</h3><p class="fs-quiz__result-sub">Please retake the quiz.</p><button type="button" class="fs-quiz__restart" data-restart>Retake the quiz</button></div>';
      engine.querySelector('[data-restart]').addEventListener('click', restart);
      return;
    }

    var cards = recs.map(function (s, i) {
      var buy = stackBuyList(s, includeTopicals);
      var price = sumPrice(buy, 'price');
      var compare = sumPrice(buy.map(function (p) { return { v: p.compare_at && p.compare_at > p.price ? p.compare_at : p.price }; }).map(function (x) { return { compare_at: x.v }; }), 'compare_at');
      var save = compare > price ? compare - price : 0;
      var variantIds = buy.map(function (p) { return p.variant_id; }).join(',');
      var displayName = /stack$/i.test((s.name || '').trim()) ? s.name : (s.name + ' Stack');
      /* admin-editable per stack (metaobject accent_color + icon); fall back to the category defaults */
      var catMeta = CAT_COLORS[s.category] || {};
      var catTone = s.accent_color || catMeta.tone || '#2B4A2D';
      var catSoft = s.accent_color ? hexToSoft(s.accent_color) : (catMeta.soft || '#EBF0EB');
      var catIconKey = s.icon || catMeta.icon || 'leaf';

      /* one product row — image + name + REAL Judge.me rating + price + add-to-cart */
      function prow(p) {
        var pImg = p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '';
        var pcompare = (p.compare_at && p.compare_at > p.price) ? '<span class="fs-quiz__prow-was">' + money(p.compare_at) + '</span>' : '';
        var rating = (p.reviews && p.reviews > 0)
          ? '<div class="fs-quiz__prow-rating"><span class="fs-quiz__prow-stars">' + starRow(p.rating) + '</span><span class="fs-quiz__prow-rcount">' + Number(p.rating).toFixed(1) + ' (' + p.reviews + ')</span></div>'
          : '';
        return '<div class="fs-quiz__prow">' +
          '<a class="fs-quiz__prow-img" href="' + (p.url || '#') + '" target="_blank" rel="noopener">' + pImg + '</a>' +
          '<div class="fs-quiz__prow-info">' +
            '<a class="fs-quiz__prow-name" href="' + (p.url || '#') + '" target="_blank" rel="noopener">' + (p.title || '') + '</a>' +
            rating +
            '<div class="fs-quiz__prow-price">' + money(p.price) + ' ' + pcompare + '</div>' +
          '</div>' +
          '<button type="button" class="fs-quiz__prow-add" data-add-stack data-variants="' + p.variant_id + '" aria-label="Add ' + (p.title || '') + ' to cart">' + PLUS + '</button>' +
        '</div>';
      }
      /* one labelled tier group (Core / Boost add-ons / Topicals) — same row design, just grouped */
      function tier(arr, label) {
        var items = tierList(arr);
        if (!items.length) return '';
        return '<div class="fs-quiz__prow-tier"><div class="fs-quiz__prow-tier-label">' + label + '</div>' +
          items.map(prow).join('') + '</div>';
      }
      var coreT = tier(s.core, 'Core');
      var boostT = tier(s.boost, 'Boost add-ons');
      var topicalT = includeTopicals ? tier(s.topical, 'Topicals & care') : '';
      var rows = coreT + boostT + topicalT;

      return '<article class="fs-quiz__pdp ' + (i === 0 ? 'is-best' : '') + '">' +
        '<div class="fs-quiz__pdp-image" style="background:' + catSoft + '">' + maskIcon(s.category, 48, catTone) +
          '<span class="fs-quiz__pdp-cat" style="color:' + catTone + '">' + (s.category || '') + '</span></div>' +
        '<div class="fs-quiz__pdp-body">' +
          '<h4 class="fs-quiz__pdp-name">' + displayName + '</h4>' +
          '<p class="fs-quiz__pdp-sub">' + (s.subtitle || '') + '</p>' +
          '<div class="fs-quiz__prows"><div class="fs-quiz__prows-label">' + buy.length + ' product' + (buy.length === 1 ? '' : 's') + ' in this stack</div>' + rows + '</div>' +
          '<div class="fs-quiz__pdp-price-row"><div><span class="fs-quiz__pdp-price">' + money(price) + '</span> ' +
            (save ? '<span class="fs-quiz__pdp-price-old">' + money(compare) + '</span> <span class="fs-quiz__pdp-price-save">· Save ' + money(save) + '</span>' : '') +
          '</div></div>' +
          '<div class="fs-quiz__pdp-actions">' +
            '<button type="button" class="fs-quiz__pdp-add" data-add-stack data-variants="' + variantIds + '">' + PLUS + ' Add whole stack</button>' +
          '</div>' +
        '</div></article>';
    }).join('');

    /* full-protocol bundle = all recommended stacks' core (+ topicals) */
    var allBuy = [];
    recs.forEach(function (s) { stackBuyList(s, includeTopicals).forEach(function (p) { allBuy.push(p); }); });
    var allVariants = allBuy.map(function (p) { return p.variant_id; }).join(',');
    /* remember every product in this result so addStack can look up selling_plan_id per variant */
    LAST_BUY = allBuy;

    /* Do ANY recommended products actually offer a subscription plan? If none do,
       don't show the toggle (nothing to subscribe to). */
    var anySub = allBuy.some(function (p) { return p.selling_plan_id && p.selling_plan_id > 0; });

    /* Delivery-frequency options for the dropdown. All products in a Matevara stack
       share the same subscription group (monthly / 2-monthly / 3-monthly), so we take
       the frequency list from the first product that has one. Each option maps a
       chosen index → per-product plan lookup at add-to-cart time. */
    var freqSource = allBuy.filter(function (p) { return p.selling_plans && p.selling_plans.length; })[0];
    var freqPlans = (freqSource && freqSource.selling_plans) || [];
    var freqSelect = (anySub && freqPlans.length > 1)
      ? '<label class="fs-quiz__freq" data-freq hidden>' +
          '<span class="fs-quiz__freq-label">Deliver</span>' +
          '<select class="fs-quiz__freq-select" data-freq-select aria-label="Delivery frequency">' +
            freqPlans.map(function (sp, i) {
              return '<option value="' + i + '">' + (sp.name || ('Plan ' + (i + 1))) + '</option>';
            }).join('') +
          '</select>' +
        '</label>'
      : '';

    var subToggle = anySub
      ? '<div class="fs-quiz__buywrap">' +
          '<div class="fs-quiz__buymode" data-buymode role="group" aria-label="Purchase option">' +
            '<button type="button" class="fs-quiz__buymode-opt is-active" data-mode="onetime" aria-pressed="true">One-time purchase</button>' +
            '<button type="button" class="fs-quiz__buymode-opt" data-mode="subscribe" aria-pressed="false">Subscribe &amp; save ' + CONFIG.discountPct + '%</button>' +
          '</div>' + freqSelect +
        '</div>'
      : '';

    engine.innerHTML = progressDots(true) +
      '<div class="fs-quiz__result">' +
        '<div class="fs-quiz__result-icon">' + TARGET + '</div>' +
        '<div class="fs-quiz__result-eyebrow">Your Personalised Stack</div>' +
        '<h3 class="fs-quiz__result-title">Your ' + goalLabel + ' <em>protocol.</em></h3>' +
        '<p class="fs-quiz__result-sub">Based on your answers, here ' + (recs.length === 1 ? 'is your Matevara stack' : 'are ' + recs.length + ' Matevara stacks') + ' built for your goals. Each one is a complete formula — pick the best fit, or take ' + allWord + ' for full coverage.</p>' +
        subToggle +
        '<div class="fs-quiz__pdps" data-count="' + recs.length + '">' + cards + '</div>' +
        (recs.length > 1 ? '<div class="fs-quiz__bundle-cta"><div class="fs-quiz__bundle-cta-text"><h4>Build your full ' + goalLabel + ' protocol</h4><p>Add ' + allWord + ' recommended stacks — all ' + recs.length + ' in one click. ' + (anySub ? 'Choose <strong>Subscribe &amp; save ' + CONFIG.discountPct + '%</strong> above, or buy once — pause or cancel anytime.' : 'Buy once; pause or cancel anytime.') + '</p></div>' +
          '<button type="button" class="fs-quiz__bundle-cta-btn" data-add-stack data-variants="' + allVariants + '">' + PLUS + ' Add Full Protocol</button></div>' : '') +
        '<button type="button" class="fs-quiz__restart" data-restart>Retake the quiz</button>' +
      '</div>';

    /* Purchase-mode toggle — flips state.subscribeMode; addStack reads it + the chosen
       frequency to attach the right selling_plan_id (real 15% off) or add one-time.
       Choosing Subscribe reveals the delivery-frequency dropdown. */
    state.subscribeMode = false;
    state.freqIndex = 0;
    var buymode = engine.querySelector('[data-buymode]');
    var freqWrap = engine.querySelector('[data-freq]');
    var freqSel = engine.querySelector('[data-freq-select]');
    if (buymode) {
      buymode.querySelectorAll('.fs-quiz__buymode-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          state.subscribeMode = opt.getAttribute('data-mode') === 'subscribe';
          buymode.querySelectorAll('.fs-quiz__buymode-opt').forEach(function (o) {
            var on = o === opt;
            o.classList.toggle('is-active', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (freqWrap) freqWrap.hidden = !state.subscribeMode;
        });
      });
    }
    if (freqSel) {
      freqSel.addEventListener('change', function () {
        state.freqIndex = parseInt(freqSel.value, 10) || 0;
      });
    }

    engine.querySelectorAll('[data-add-stack]').forEach(function (b) { b.addEventListener('click', addStack); });
    engine.querySelector('[data-restart]').addEventListener('click', restart);
    engine.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  /* variant_id → selling_plan_id lookup for the CURRENTLY chosen frequency. Falls back
     to the product's default plan if the chosen frequency index isn't available. */
  function planForVariant(vid) {
    var hit = (LAST_BUY || []).filter(function (p) { return String(p.variant_id) === String(vid); })[0];
    if (!hit) return 0;
    var idx = (state.freqIndex || 0);
    if (hit.selling_plans && hit.selling_plans[idx]) return hit.selling_plans[idx].id;
    return hit.selling_plan_id || 0;
  }

  function addStack(e) {
    var btn = e.currentTarget;
    var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
    if (!ids.length || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var sub = !!state.subscribeMode;
    var items = ids.map(function (id) {
      var item = { id: parseInt(id, 10), quantity: 1 };
      if (sub) { var sp = planForVariant(id); if (sp) item.selling_plan = sp; }
      return item;
    });
    var drawer = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(json);
        if (typeof window.fsUpdateCartCounts === 'function') window.fsUpdateCartCounts();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: json }));
        if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('open')) drawer.open();
        btn.classList.remove('is-loading');
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function restart() {
    state = { step: 0, answers: {}, selected: null, multi: [], gatePassed: LOGGED_IN };
    clearState();
    renderQuestion();
  }

  /* ---- FAQ accordion (delegated) ---- */
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-fs-faq-toggle]');
    if (!q) return;
    var item = q.closest('.fs-quiz__faq-item');
    var open = item.classList.contains('is-open');
    root.querySelectorAll('.fs-quiz__faq-item').forEach(function (i) { i.classList.remove('is-open'); i.querySelector('[data-fs-faq-toggle]').setAttribute('aria-expanded', 'false'); });
    if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
  });

  /* ---- go ---- */
  if (STACKS.length === 0) {
    engine.innerHTML = '<p style="text-align:center;color:#5C5650;padding:24px;">No stacks configured yet. Add them in Settings → Custom data → Quiz Stack.</p>';
  } else {
    /* Restore any in-progress quiz saved before a refresh. If the saved step was
       past the questions, resume at the gate/result; otherwise resume mid-quiz. */
    var restored = loadState();
    if (restored && state.step >= QUIZ.length) {
      if (state.gatePassed) renderResult(); else renderGate();
    } else {
      renderQuestion();
    }
  }
})();
